import { trackSiteEvent } from './siteAnalytics';

const META_PIXEL_ID = '4346436365385134';
const SUBMIT_MUSIC_INTENT_EVENT = 'SubmitMusicIntent';

let initialized = false;

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  initialized = true;

  if (!window.fbq) {
    const fbq = function fbq() {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }

  window.fbq('init', META_PIXEL_ID);
}

export function trackSubmitMusicIntent(params = {}) {
  if (typeof window === 'undefined') return;
  trackSiteEvent('submit_music_intent', {
    intent: 'artist_submission',
    destination: '/submit-your-music',
    event_source: 'ivagonzo_site',
    ...cleanParams(params),
  });
  initMetaPixel();
  if (typeof window.fbq !== 'function') return;

  window.fbq('trackCustom', SUBMIT_MUSIC_INTENT_EVENT, {
    intent: 'artist_submission',
    destination: '/submit-your-music',
    event_source: 'ivagonzo_site',
    ...cleanParams(params),
  });
}

export function handleSubmitMusicIntentClick(event, params = {}) {
  trackSubmitMusicIntent(params);

  if (!event || event.defaultPrevented) return;
  const anchor = event.currentTarget;
  const href = anchor?.href || '';
  if (!href) return;

  const isPlainLeftClick =
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey;
  const target = String(anchor.getAttribute('target') || '').toLowerCase();
  if (!isPlainLeftClick || target === '_blank') {
    return;
  }

  event.preventDefault();
  window.setTimeout(() => {
    window.location.assign(href);
  }, 180);
}

function cleanParams(params) {
  const output = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value == null) return;
    const text = String(value).trim();
    if (!text) return;
    output[key] = text;
  });
  return output;
}
